import {Layers, WalkOfShameLayers} from "./WalkOfShameLayers";
import {WalkOfShameGameAssets} from "../WalkOfShameGameAssets";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/text/BitmapTextStyleOptions";
import {TimelineLite} from "gsap";
import {WalkOfShame} from "../WalkOfShame";
import {IBetWinData} from "../server/data/IWalkOfShameData";

export class WalkOfShameWinWays extends PIXI.Container {
    private _bgOverlay: PIXI.Sprite;
    private _winWaysNumber: PIXI.BitmapText;
    private _toggleWinAmount: PIXI.BitmapText;

    constructor() {
        super();

        this.init();
        WalkOfShameLayers.getLayer(Layers.WIN_WAYS)!.addChild(this._bgOverlay, this._winWaysNumber, this._toggleWinAmount);
    }

    // #183
    public showWinAmountNWaysOnInitialWin(betWins: IBetWinData[], isSingleWinBelowStake: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            container: PIXI.Container = new PIXI.Container();

        if (isSingleWinBelowStake) {
            return tl;
        }

        container.position.set(360);
        container.alpha = 0;

        betWins.forEach((betWay: IBetWinData, idx: number) => {
            const winAmount: PIXI.BitmapText = new PIXI.BitmapText(betWay.multipliedAmount.toFixed(2), {
                    fontName: WalkOfShameGameAssets.BITMAP_FONT_WIN_COUNT_UP,
                    fontSize: 18
                }),
                waysAmount: PIXI.BitmapText = new PIXI.BitmapText(betWay.numberOfCombinations + (betWay.numberOfCombinations > 1 ? 'W' : 'w'), {
                    fontName: WalkOfShameGameAssets.BITMAP_WAYS_COUNT_UP,
                    fontSize: 28
                });

            winAmount.y = (idx * 30) + (idx * 60);
            winAmount.pivot.set(winAmount.width / 2, winAmount.height / 2);

            waysAmount.y = (winAmount.y + 35);
            waysAmount.pivot.set(waysAmount.width / 2, waysAmount.height / 2);

            container.addChild(waysAmount, winAmount);
        });

        if (betWins.length > 5) {
            container.scale.set(0.5);
        }
        container.y -= (container.height / 2);

        WalkOfShameLayers.getLayer(Layers.WIN_WAYS)!.addChild(container);

        tl.to(container, {
            duration: 0.1,
            alpha: 1
        });
        tl.to(container, {
            duration: 0.3,
            y: "-=50"
        });
        tl.to(container, {
            duration: 0.1,
            alpha: 0
        });
        tl.add(() => {
            container.removeChildren();
            WalkOfShameLayers.getLayer(Layers.WIN_WAYS)!.removeChild(container);
        });

        return tl;
    }

    public showWinWays(winWaysNumber: number, yPos: number): void {
        this._winWaysNumber.text = winWaysNumber + (winWaysNumber > 1 ? 'W' : 'w');
        this._winWaysNumber.visible = true;
        this._winWaysNumber.alpha = 1;
        this._winWaysNumber.y = yPos;
    }

    public hideInitialWinWays(): void {
        const duration: number = 0.3,
            tl: TimelineLite = new TimelineLite();

        tl.to([this._winWaysNumber, this._bgOverlay], {
            duration: duration,
            alpha: 0,
            onComplete: () => {
                this._winWaysNumber.visible = false;
                this._bgOverlay.visible = false;
            }
        });
    }

    public showToggleWinAmountNWays(toggleWinAmount: number, winWaysNumber: number): void {
        // #72
        if (!WalkOfShame.model.parsedGameData.brokeTheBank) {
            this.showWinWays(winWaysNumber, 455);

            // #119
            this._bgOverlay.visible = true;
            this._bgOverlay.alpha = 0.8;
        }
        this._toggleWinAmount.fontSize = 32;
        this._toggleWinAmount.text = toggleWinAmount.toFixed(2);
        while (this._toggleWinAmount.textWidth > 680) {
            this._toggleWinAmount.fontSize--;
        }
        this._toggleWinAmount.visible = true;
        this._toggleWinAmount.alpha = 1;
    }

    public hideToggleWinAmountNWays(): void {
        if (!this._toggleWinAmount.visible) {
            return;
        }

        const duration: number = 0.2,
            tl: TimelineLite = new TimelineLite();

        tl.to([this._winWaysNumber, this._toggleWinAmount, this._bgOverlay], {
            duration: duration,
            alpha: 0,
            onComplete: () => {
                this._winWaysNumber.visible = false;
                this._toggleWinAmount.visible = false;
                this._bgOverlay.visible = false;
            }
        });
    }

    private init(): void {
        const waysWonStyle: BitmapTextStyleOptions = {
                fontName: WalkOfShameGameAssets.BITMAP_WAYS_COUNT_UP,
                fontSize: 50,
                tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
            },
            winAmountStyle: BitmapTextStyleOptions = {
                fontName: WalkOfShameGameAssets.BITMAP_FONT_WIN_COUNT_UP,
                fontSize: 32,
                tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
            };

        this._bgOverlay = new PIXI.Sprite(WalkOfShame.assetLoader.getTextures("countUpBgOverlay")[0]);
        this._bgOverlay.visible = false;
        this._bgOverlay.alpha = 0.8;
        this._bgOverlay.position.set(360, 435);
        this._bgOverlay.anchor.set(0.5);
        this._bgOverlay.width = 500;
        this._bgOverlay.height = 400;

        this._winWaysNumber = new PIXI.BitmapText("", waysWonStyle);
        this._winWaysNumber.visible = false;
        this._winWaysNumber.anchor = new PIXI.Point(0.5);
        this._winWaysNumber.position.set(360, 455);

        this._toggleWinAmount = new PIXI.BitmapText("", winAmountStyle);
        this._toggleWinAmount.visible = false;
        this._toggleWinAmount.anchor = new PIXI.Point(0.5);
        this._toggleWinAmount.position.set(360, 370);
    }
}